import {useState, useTransition} from 'react';

import {useQueryState} from 'shared/web';

import {ServiceVehicleFormTabs} from '../types/ServiceVehicleFormTabs';

const QUERY_TAB_KEY = 'tab';

export function useTabs() {
  const [queryTab, setQueryTab] = useQueryState(QUERY_TAB_KEY, true);
  const [isPending, startTransition] = useTransition();

  const [selectedInnerTab, setSelectedInnerTab] = useState<ServiceVehicleFormTabs>(
    (queryTab || ServiceVehicleFormTabs.BasicInformation) as ServiceVehicleFormTabs
  );

  const setSelectedTab = (newTab: ServiceVehicleFormTabs) => {
    setSelectedInnerTab(newTab);
    startTransition(() => {
      setQueryTab(newTab);
    });
  };

  return {selectedTab: selectedInnerTab, isPending, setSelectedTab};
}
